/**
 * Constroi o bloco user_data com dados hashados em SHA-256
 * para o dataLayer (Meta Ads Enhanced Match / CAPI).
 *
 * Campos sem valor sao omitidos (nunca envia string vazia ou null).
 */
import { sha256, normEmail, normPhone, normName, normCity, normState, normZip } from "./hash";

export interface UserMetaInput {
  email?: string | null;
  phone?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  id?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  country?: string | null;
  birthday?: string | null;
  gender?: string | null;
}

export interface UserDataMeta {
  em?: string;
  ph?: string;
  fn?: string;
  ln?: string;
  external_id?: string;
  ct?: string;
  st?: string;
  zp?: string;
  country?: string;
  db?: string;
  ge?: string;
}

export async function buildUserDataForMeta(user: UserMetaInput): Promise<UserDataMeta> {
  const ud: UserDataMeta = {};

  if (user.email) ud.em = await sha256(normEmail(user.email));
  if (user.phone) ud.ph = await sha256(normPhone(user.phone));
  if (user.firstName) ud.fn = await sha256(normName(user.firstName));
  if (user.lastName) ud.ln = await sha256(normName(user.lastName));
  if (user.id) ud.external_id = await sha256(String(user.id));
  if (user.city) ud.ct = await sha256(normCity(user.city));
  if (user.state) ud.st = await sha256(normState(user.state));
  if (user.zip) ud.zp = await sha256(normZip(user.zip));
  if (user.country) ud.country = await sha256(user.country.toLowerCase().trim());
  if (user.birthday) {
    // Normalizar para YYYYMMDD (aceita ISO 2000-01-15 ou ja formatado)
    const clean = user.birthday.replace(/\D/g, "").slice(0, 8);
    if (clean.length === 8) ud.db = await sha256(clean);
  }
  if (user.gender) {
    const g = user.gender.toLowerCase();
    if (g === "masculino" || g === "m" || g === "male") ud.ge = await sha256("m");
    else if (g === "feminino" || g === "f" || g === "female") ud.ge = await sha256("f");
  }

  return ud;
}
